const DesktopLoader = () => {
  return (
    <div className="bg-dark-8 grid w-full grid-cols-[minmax(0,1.5fr)_minmax(0,3.5fr)_minmax(0,1.5fr)_minmax(0,2.3fr)_minmax(0,0.5fr)_minmax(0,1.2fr)_minmax(0,1.5fr)] rounded-md ">
      <div className="text-center font-medium px-5 py-3 ">
        {" "}
        <div className="animate-pulse flex space-x-4 col-span-6 ">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-5 bg-slate-200 rounded col-span-1"></div>
          </div>
        </div>
      </div>
      <div className="text-center font-medium px-5 py-3 ">
        {" "}
        <div className="animate-pulse flex space-x-4 col-span-6 ">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-5 bg-slate-200 rounded col-span-1"></div>
          </div>
        </div>
      </div>
      <div className="text-center font-medium px-5 py-3 ">
        {" "}
        <div className="animate-pulse flex space-x-4 col-span-6 ">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-5 bg-slate-200 rounded col-span-1"></div>
          </div>
        </div>
      </div>
      <div className="text-center font-medium px-5 py-3 ">
        {" "}
        <div className="animate-pulse flex space-x-4 col-span-6 ">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-5 bg-slate-200 rounded col-span-1"></div>
          </div>
        </div>
      </div>
      <div className="text-center font-medium px-5 py-3 ">
        {" "}
        <div className="animate-pulse flex space-x-4 col-span-6 ">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-5 bg-slate-200 rounded col-span-1"></div>
          </div>
        </div>
      </div>
      <div className="text-center font-medium px-5 py-3 ">
        {" "}
        <div className="animate-pulse flex space-x-4 col-span-6 ">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-5 bg-slate-200 rounded col-span-1"></div>
          </div>
        </div>
      </div>
      <div className="text-center font-medium px-5 py-3 ">
        <div className="animate-pulse flex space-x-4 col-span-6 ">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-5 bg-slate-200 rounded col-span-1"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DesktopLoader
